import React, { useState } from 'react'
import { Panel, Whisper, Tooltip } from 'rsuite'
import EditIcon from '@rsuite/icons/Edit'
import DefaultFarmIcon from '../../../assets/images/default-farm.svg'
import './CardTable.scss'
import '../../../pages/profile/createEditProfile/CreateEditProfile.scss'

interface DocumentCardProps extends React.ComponentProps<typeof Panel> {
  title?: string;
  imageUrl: string;
  subtitle?: string;
  status?: string;
  data?: any;
  number?: string;
  onEdit?: (data?: any) => void;
}

const DocumentCard: React.FC<DocumentCardProps> = ({
  title = 'Document Name',
  imageUrl,
  subtitle,
  number = 'VT-PAN-3456',
  status,
  data,
  onEdit
}) => {
  const [imgSrc, setImgSrc] = useState(imageUrl)
  const isPdf = imageUrl?.endsWith('.pdf')

  const handleImageError = () => {
    setImgSrc(DefaultFarmIcon)
  }
  const canEdit = ['rejected', 'pending'].includes((status ?? '').toLowerCase())

  const handleEditClick = () => {
    if (onEdit) {
      onEdit(data)
    }
  }
  const getStatusTooltip = () => {
    switch (status?.toLowerCase()) {
      case 'accepted':
        return 'Your document is Verified'
      case 'pending':
        return 'Your document verification is Pending '
      case 'rejected':
        return 'Your document is Rejected'
      default:
        return `Your document status is ${status}`
    }
  }
  return (
    <div className="card document-card">
      <div className="card-header">
        {isPdf ? (
          <embed
            src={imageUrl}
            type="application/pdf"
            width="100%"
            height="115px"
            className="pdf-preview"
          />
        ) : (
          <img src={imgSrc} alt={subtitle} onError={handleImageError} />
        )}
      </div>
      <div className="dc-card-body">
        <div className="dc-status-row">
          <Whisper
            placement="bottom"
            trigger="hover"
            speaker={<Tooltip>{getStatusTooltip()}</Tooltip>}
          >
            <div className={`card-status ${status?.toLowerCase()}`}>
              <h6>{status === 'Accepted' ? 'Verified' : status}</h6>
            </div>
          </Whisper>
          {canEdit && (
            <Whisper
              placement="bottom"
              trigger="hover"
              speaker={<Tooltip>Edit</Tooltip>}
            >
              <button
                type="button"
                className="edit-btn"
                onClick={handleEditClick}
                aria-label="Edit document"
              >
                <EditIcon />
              </button>
            </Whisper>
          )}
        </div>
        <div className="dc-card-header">
          <h3>{title}</h3>
        </div>
        <div className="card-number">
          <h3>{number}</h3>
        </div>
      </div>
    </div>
  )
}

export default DocumentCard
